import Home from './components/Home/Home.js';
import './styles/fonts.css';
import './styles/fontSizes.css';

function App() {
  return (
    <Home/>
  );
}

export default App;
